export enum PostingChannel {
  Common = 1,
  ACC = 2,
}
